// export const getPriceByCurrency = (
//   price?: string | number | null,
//   currency = 'USD',
// ): string | undefined => {
//   if (typeof price === 'string') return price;
//   if (typeof price !== 'number') return;

//   return new Intl.NumberFormat('en-US', {
//     style: 'currency',
//     currency: currency,
//   }).format(price);
// };

import { DEFAULT_CURRENCY_ANALYTIC } from '~/modules/analytics/constants/report';

export interface GetPriceByCurrencyOptions {
  locale?: string;
  /** Use compact notation (1K, 1M, 1B) for thousands+ */
  compact?: boolean;
}

export const getPriceByCurrency = (
  price?: string | number | null,
  currency = DEFAULT_CURRENCY_ANALYTIC,
  options?: string | GetPriceByCurrencyOptions,
): string | undefined => {
  if (typeof price === 'string') return price;
  if (typeof price !== 'number') return;

  // Support legacy 3rd arg as locale string
  const opts = typeof options === 'string' ? { locale: options } : options;
  const locale = opts?.locale ?? 'en-US';

  if (price >= 1_000_000_000) {
    return `${new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(price / 1_000_000_000)}B`;
  }

  if (price >= 1_000_000) {
    return `${new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(price / 1_000_000)}M`;
  }

  if (opts?.compact && Math.abs(price) >= 1_000) {
    return `${new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(price / 1_000)}K`;
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(price);
};

export const formatCurrency = (
  value?: string | number | null,
  currency = DEFAULT_CURRENCY_ANALYTIC,
): string | undefined => {
  if (typeof value === 'string') return value;
  if (typeof value !== 'number') return;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(value);
};

/**
 * Get the currency symbol for a given currency and locale.
 * @param currency - Currency code (e.g., "USD", "EUR")
 * @param locale - Locale code (e.g., "en-US", "fr-FR")
 * @returns Currency symbol (e.g., "$", "€")
 */
export const getCurrencySymbol = (currency = 'USD', locale = 'en-US'): string => {
  if (!locale || !currency.trim()) return '';
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  });
  const parts = formatter.formatToParts(0); // Format số 0 để lấy parts
  const currencyPart = parts.find((part) => part.type === 'currency');
  return currencyPart?.value || '';
};
